import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '../_helpers';
import { clearReturnUrl, redirectToReturnUrl } from '../_helpers/returnUrl';

// create slice

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}

function createReducers() {
    return {
        logout
    };

    function logout(state) {
        state.user = null;
        localStorage.removeItem('user');
        localStorage.removeItem('ccValue');
        clearReturnUrl();
        history.navigate('/login');
        localStorage.removeItem('filterObjValues');
        localStorage.removeItem('copyLocalObj');
        localStorage.removeItem('reimbersementFilterObjValues');
        localStorage.removeItem('reimbersementcopyLocalObj');
        localStorage.removeItem('mileageFilterObjValues');
        localStorage.removeItem('mileagecopyLocalObj');
        localStorage.removeItem('missingReceiptsCopyLocalObj');
        localStorage.removeItem('missingReceiptsFilterValues');
        
        
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        login: login()
    };    

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async (postData) => await fetchWrapper.post(`${baseUrl}/authenticate`, { postData })
        );
    }
}

function createExtraReducers() {
    return {
        ...login()
    };

    function login() {
        var { pending, fulfilled, rejected } = extraActions.login;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const user = action.payload;
                
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                state.user = user;

                redirectToReturnUrl(user);
            },
            [rejected]: (state, action) => {
                state.error = action.error;
            }
        };
    }
}
